__turbopack_context__.v({
  "button": "POfe2a_button",
  "container": "POfe2a_container",
  "hideOnMd": "POfe2a_hideOnMd",
  "hideOnSm": "POfe2a_hideOnSm",
  "hideOnXs": "POfe2a_hideOnXs",
  "iconNext": "POfe2a_iconNext",
  "image": "POfe2a_image",
  "item": "POfe2a_item",
  "lightBox": "POfe2a_lightBox",
  "next": "POfe2a_next",
  "prev": "POfe2a_prev",
  "service": "POfe2a_service",
  "servicePrice": "POfe2a_servicePrice",
  "serviceTitle": "POfe2a_serviceTitle",
  "sliderContainer": "POfe2a_sliderContainer",
  "swiperContainer": "POfe2a_swiperContainer",
  "swiperWrapper": "POfe2a_swiperWrapper",
  "title": "POfe2a_title",
});
